// extracted by mini-css-extract-plugin
export default {"home":"Exams_home__fVrx3","home2":"Exams_home2__KyvLy","main":"Exams_main__f7yq9","brmedium":"Exams_brmedium__xvLLH"};